<template>
  <div class="container">
    <div class="cells">
      <div class="cell text-center">
        <a href="javascript:;" class="action-back iconfont" @click.prevent="$router.push('/')"></a>
        <img class="brand" src="/static/images/brand-login.png">
        <div class="divider"></div>
        <form method="post" @submit.prevent="login">
          <div class="input-group">
            <div class="input-group-addon">
              <span class="iconfont">&#xe605;</span>
            </div>
            <input type="tel" v-model="phone" class="form-control" placeholder="请输入手机号">
          </div>
          <div class="input-group">
            <div class="input-group-addon">
              <span class="iconfont">&#xe609;</span>
            </div>
            <input type="text" v-model="captText" class="form-control" placeholder="请输入图形验证码">
            <div class="input-group-btn">
              <a @click.prevent="updateCapt">
                <img class="icon" :src="captUrl">
              </a>
            </div>
          </div>
          <div class="input-group">
            <div class="input-group-addon">
              <span class="iconfont">&#xe606;</span>
            </div>
            <input type="password" v-model="password" class="form-control" placeholder="请输入密码">
          </div>
          <p class="help-text text-right">
            <router-link to="/auth/reset">忘记密码</router-link>
          </p>
          <div class="divider"></div>
          <div class="btn-group">
            <button type="submit" class="btn btn-round">{{btnText}}</button>
          </div>
          <div class="divider"></div>
          <div class="btn-group">
            <router-link class="btn btn-outline" to="/auth/register">注册</router-link>
          </div>
        </form>
      </div>
    </div>
    <toast :show="toastShow" :text="toastText" @hidden="toastShow=false"></toast>
    <spinner :show="loading"></spinner>
  </div>
</template>

<script>
  import Toast from 'components/toast/toast'
  import Spinner from 'components/spinner/spinner'

  export default {
    data () {
      return {
        loading: false,
        toastShow: false,
        toastText: '',
        btnText: '登录',
        captUrl: '',
        phone: '',
        captText: '',
        password: ''
      }
    },
    components: {Toast, Spinner},
    created () {
      if (this.$from().isInner) {
        this.btnText = '绑定'
      }
      this.updateCapt()
    },
    methods: {
      validate () {
        if (!this.phone) {
          this.toastText = '请输入手机号'
          return !(this.toastShow = true)
        }
        if (!this.captText) {
          this.toastText = '请输入图形验证码'
          return !(this.toastShow = true)
        }
        if (!this.password) {
          this.toastText = '请输入密码'
          return !(this.toastShow = true)
        }
        return true
      },
      updateCapt () {
        this.captUrl = this.$cache.updateCapt()
      },
      login () {
        if (this.validate()) {
          let vm = this
          let params = {
            phone: this.phone,
            password: this.$md5(this.password),
            captId: this.$cache.getCaptId(),
            captText: this.captText
          }
          let url = '/login.jhtml'
          if (this.$from().isInner) {
            url = '/bindWx.jhtml'
            let time = Date.now()
            let cache = this.$parseParams(this.$cache.getCache() || '')
            params = this.$assign({}, params, cache, {
              time,
              sign: this.$md5(cache.appID + cache.msgId + time)
            })
          }
          this.loading = true
          this.$ajax({
            url,
            params,
            done (data) {
              vm.$cache.setUserToken(vm.$assign(data, {
                phone: vm.phone
              }))
              let backurl = vm.$route.query.backurl
              if (backurl) {
                window.location.href = backurl
                return
              }
              if (data.status === 0) {
                vm.$router.replace('/auth/authentication')
              } else {
                vm.$router.replace('/user')
              }
            },
            fail (msg) {
              vm.$dialog(msg)
              vm.updateCapt()
            },
            always () {
              vm.loading = false
            }
          })
        }
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  @import '../../common/css/mixmin'

  color = #3b7fe7

  a
    color color
  .container
    position absolute
    top 0
    left 0
    width 100%
    height 100%
    overflow hidden
    font-size px2rem(28px)
    color color

  .cells
    display table
    width 70%
    height 100%
    margin-left 15%
    .cell
      display table-cell
      vertical-align middle

  .action-back
    position absolute
    top 0
    left px2rem(10px)
    width px2rem(80px)
    z-index 100
    line-height px2rem(88px)
    font-size px2rem(32px)
    text-align center
    &:before
      content '\e65b'

  .divider
    height px2rem(80px)

  .brand
    height px2rem(100px)

  .input-group
    display table
    width 100%
    & + .input-group
      margin-top px2rem(40px)
    .form-control
      display table-cell
      width 100%
      height px2rem(80px)
      padding 0
      padding-top px2rem(20px)
      font-size px2rem(28px)
      color color
      background none
      border none
      border-radius 0
      border-bottom 1px solid #3b6897
      &::-webkit-input-placeholder
        color color
    .input-group-addon, .input-group-btn
      display table-cell
      vertical-align middle
      white-space nowrap
      font-size 0
    .input-group-addon
      width 15%
      vertical-align bottom
      .iconfont
        font-size px2rem(48px)
        line-height 1
    .input-group-btn
      width px2rem(130px)
      border-bottom 1px solid #3b6897
      > a
        display block
        height 100%
        font-size 0
        .icon
          width 100%
          height px2rem(68px)
  .help-text
    margin 0
    line-height px2rem(60px)
  .btn
    display block
    width 100%
    font-size px2rem(32px)
    line-height px2rem(80px)
    letter-spacing px2rem(4)
    background none
    border none
    border-radius px2rem(40px)
    box-shadow 0 0 4px rgba(18,119,163,.75)
    &.btn-round
      color #fff
      background-color #60c9c8
    &.btn-outline
      color #60c9c8
      border 1px solid #60c9c8
</style>



// WEBPACK FOOTER //
// login.vue?1b74e282